// skinTagsRemovalData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const skinTagsRemoval: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Skin Tags Removal Dubai - Elite Body Home Dubai",
            "description": "Discover expert skin tags removal dubai services at Elite Body Home in Dubai. Achieve your desired results with professional care and personalized treatments.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/skin-tags-removal-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Skin Tags Removal Dubai - Elite Body Home Dubai",
                "description": "Discover expert skin tags removal dubai services at Elite Body Home in Dubai. Achieve your desired results with professional care and personalized treatments.",
                "url": "https://elitebodyhome.com/services/skin-tags-removal-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:53:49+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Skin Tags Removal",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Skin Tags Removal Dubai - Elite Body Home Dubai",
                "description": "Discover expert skin tags removal dubai services at Elite Body Home in Dubai. Achieve your desired results with professional care and personalized treatments.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg"
            },

        },
        "breadcrumbs": ["Home", "Services", "Skin Tags Removal Dubai"],
        "hero": {
            "title": "Skin Tags Removal Dubai",
            "subtitle": "Remove Skin Tags for a Clear, Smooth Finish",
            "description": "Skin tags are small, harmless growths that generally develop in areas where skin rubs against skin or clothing, including the neck, armpits and groin. While harmless, they can be awkward or make people feel self-conscious, especially if they grow in places that are visible. Skin tag removal is a safe & non-invasive treatment that offers a simple way to get rid of extra skin on the body & promote smooth, clear skin."
        },
        "howItWorks": {
            "title": "Procedure",
            "description": "Skin tag removal is a quick and safe treatment that helps to remove non-cancerous lumps on the skin."
        },
        "procedureSteps": {
            "heading": "Here's a rundown of how common methods work:",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A dermatologist examines the skin tag to ensure it is benign and discusses the best method of removal.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Cryotherapy",
                    "desc": "Liquid nitrogen freezes the skin tag, which then falls off on its own after a few days.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Excision",
                    "desc": "Using a sterile instrument, the skin tag is cut off in a process that is done under local anesthesia for a painless experience.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Ligation",
                    "desc": "A thread is tied around the base of the skin tag, squeezing off blood supply until it eventually flakes off.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "Electrosurgery",
                    "desc": "An electric current fries off the skin tag and seals the wound, minimizing bleeding.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "Removing a skin tag can be cosmetic and health related.",
            "para": "Removing these small growths will help you restore the appearance of your skin and prevent possible irritation or infection.",
            "items": [
                {
                    "title": "Improved skin appearance",
                    "desc": "Unsightly skin tags are removed, which enhances the smoothness and clarity of your skin.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Increased comfort",
                    "desc": "Skin tags may snag on clothing or jewelry, resulting in pain and bleeding. Removing them one gets rid of these risks.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "Hygiene benefits",
                    "desc": "Skin tags can also trap bacteria in sweat-prone regions, potentially leading to skin irritation. Removal encourages better hygiene of the skin.",
                    "icon": "fa-solid fa-hands-bubbles"
                },
                {
                    "title": "Prevention of further growth",
                    "desc": "Although skin tags are harmless, removing them stops them from getting larger or proliferating down the line.",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "The vast majority of people with skin tags are candidates for removal",
            "para": "The treatment will differ based on the size, location, and quantity of the tags.",
            "items": [
                {
                    "title": "People with skin tags on visible areas",
                    "desc": "Especially on the face, neck or eyelids where they can lead to cosmetic issues.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "For those not feeling well",
                    "desc": "Skin tags in sensitive areas, such as the underarms or groin, can rub against other skin or clothing, leading to irritation or bleeding.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "People prone to infections",
                    "desc": "An irritated and inflamed skin tag can be prone to infection.",
                    "icon": "fa-solid fa-bacteria"
                },
                {
                    "title": "For anyone in search of a lasting fix",
                    "desc": "Skin tags are benign, but removal means they won't reappear in the same place.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "How to Prepare for Skin Tag Removal Procedure",
            "para": "Before your skin tag removal procedure, it's important to prepare properly to ensure a smooth and effective treatment.",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "Book an appointment with a medical professional to evaluate your skin tags and recommend the best removal option.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Avoid certain products",
                    "desc": "Avoid any aggressive antimicrobials, exfoliating agents and/or retinoids on the area that will be treated for the skin tag.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Stay hydrated",
                    "desc": "Skin that's well-hydrated tends to recover more quickly, so make sure you're drinking enough water in the days before the procedure.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid sun exposure",
                    "desc": "If you can help it, avoid any sun damage to your skin prior to treatment because it can further aggravate irritation during healing.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Patients are left with smooth skin, free from this blemish and with minimal downtime following skin tag removal. The area that has been treated may be a little red or tender for a small amount of time, but it usually goes away in a few days.",
            "items": [
                {
                    "title": "Immediate improvement",
                    "desc": "The skin tags are removed immediately and offer immediate cosmetic improvement.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Minimal scarring",
                    "desc": "The risk of scarring is low when performed by a trained professional.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "Quick recovery",
                    "desc": "Most patients go home the same day and do not require long periods of downtime.",
                    "icon": "fa-solid fa-house-medical"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is skin tag removal painful?",
                    "answer": "Most skin tag removal procedures cause minimal discomfort. Local anesthesia or numbing cream is usually applied to the area, making the procedure virtually painless."
                },
                {
                    "question": "Will skin tags grow back after removal?",
                    "answer": "While removed skin tags do not grow back, new ones can form in other areas. Maintaining healthy skin habits and regularly monitoring your skin can help prevent this."
                },
                {
                    "question": "How long does recovery take?",
                    "answer": "Recovery is typically quick, with most patients resuming their daily activities immediately. Slight redness or tenderness may be experienced but usually subsides within a few days."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannedfdsr-Image-1-scaled.jpg",
            "beforeAfter": [
                'https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mole-Removal-Dubaiss-1.jpg',
                'https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mole-Removal-Dubaiss-2.jpg',
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mole-Removal-Dubaiss-3.jpg"
            ]
        },
        "product": {
            "id": 122,
            "title": "Skin Tags Removal",
            "price": 399,
            "description": "Discover expert skin tags removal dubai services at Elite Body Home in Dubai. Achieve your desired results with professional care and personalized treatments."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "إزالة الزوائد الجلدية في دبي - عيادة إيليت بودي هوم دبي",
            "description": "اكتشف خدمات إزالة الزوائد الجلدية في دبي لدى عيادة إيليت بودي هوم. احصل على النتائج المرجوة برعاية احترافية وعلاجات مخصصة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/skin-tags-removal-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "إزالة الزوائد الجلدية في دبي - عيادة إيليت بودي هوم دبي",
                "description": "اكتشف خدمات إزالة الزوائد الجلدية في دبي لدى عيادة إيليت بودي هوم. احصل على النتائج المرجوة برعاية احترافية وعلاجات مخصصة.",
                "url": "https://elitebodyhome.com/services/skin-tags-removal-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:53:49+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "إزالة الزوائد الجلدية",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "إزالة الزوائد الجلدية في دبي - عيادة إيليت بودي هوم دبي",
                "description": "اكتشف خدمات إزالة الزوائد الجلدية في دبي لدى عيادة إيليت بودي هوم. احصل على النتائج المرجوة برعاية احترافية وعلاجات مخصصة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/wfegregreg.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة الزوائد الجلدية في دبي"],
        "hero": {
            "title": "إزالة الزوائد الجلدية في دبي",
            "subtitle": "تخلص من الزوائد الجلدية للحصول على بشرة ناعمة وصافية",
            "description": "الزوائد الجلدية هي نموات جلدية صغيرة غير ضارة، تظهر غالبًا في مناطق احتكاك الجلد ببعضه أو بالملابس مثل الرقبة وتحت الإبط والفخذ. ورغم أنها غير ضارة، إلا أنها قد تُسبب الإزعاج أو الإحراج خصوصًا عندما تنمو في مناطق واضحة. يُعد إزالة الزوائد الجلدية إجراء آمن وغير جراحي، يوفر طريقة بسيطة للتخلص من الجلد الزائد وتحسين نعومة ونقاء البشرة."
        },
        "howItWorks": {
            "title": "الإجراء",
            "description": "تُعد إزالة الزوائد الجلدية علاجًا سريعًا وآمنًا للتخلص من النتوءات الجلدية غير السرطانية."
        },
        "procedureSteps": {
            "heading": "إليك نظرة عامة على أكثر الطرق شيوعًا:",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يفحص الطبيب الزائدة الجلدية ليتأكد من إنها حميدة، ويُناقش أنسب طريقة لإزالتها.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "العلاج بالتبريد",
                    "desc": "يُستخدم النيتروجين السائل لتجميد الزائدة الجلدية، فتجف وتسقط من تلقاء نفسها خلال أيام.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "العلاج بالاستئصال",
                    "desc": "تُقطع الزائدة الجلدية بأداة معقمة، تحت تأثير التخدير الموضعي لضمان تجربة خالية من الألم.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "العلاج بالربط",
                    "desc": "يتم ربط خيط رفيع حول قاعدة الزائدة لقطع تدفق الدم عنها، مما يؤدي إلى سقوطها لاحقًا.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "العلاج بالجراحة الكهربائية",
                    "desc": "يُستخدم تيار كهربائي لحرق الزائدة الجلدية وإغلاق الجرح في الوقت ذاته، مما يُقلل من النزيف.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "يمكن أن تكون أسباب التخلص من الزوائد الجلدية تجميلية وصحية في ذات الوقت",
            "para": "حيث تساعدك إزالة هذه النموات الصغيرة على استعادة نعومة الجلد، وتقلل من احتمالية تهيج الجلد أو العدوى.",
            "items": [
                {
                    "title": "تحسن ملمس البشرة",
                    "desc": "تُزال الزوائد الجلدية غير المرغوب فيها، مما يمنح البشرة مظهرًا أنعم وأكثر صفاءً.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "زيادة الراحة",
                    "desc": "قد تعلق الزوائد الجلدية بالملابس أو الإكسسوارات، مما يسبب ألمًا أو نزيفًا. يُخلصك إزالتها من هذه المخاطر.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "فوائد صحية",
                    "desc": "يمكن أن تحتجز الزوائد الجلدية البكتيريا خاصةً في المناطق المعرضة للتعرق، ما قد يسبب تهيجًا للجلد. يُحسن الإزالة من نظافة البشرة.",
                    "icon": "fa-solid fa-hands-bubbles"
                },
                {
                    "title": "الوقاية من تفاقم نمو الزوائد الجلدية",
                    "desc": "رغم أن الزوائد الجلدية غير ضارة، فإن إزالتها تمنعها من النمو أو التكاثر.",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "تُعد الغالبية العظمى من الأشخاص الذين يعانون من الزوائد الجلدية مؤهلين لإزالتها",
            "para": "ولكن قد تختلف طريقة العلاج حسب حجم الزائدة، ومكانها، وعددها.",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من الزوائد الجلدية في أماكن مرئية",
                    "desc": "قد تُسبب الزوائد الجلدية مظهرًا غير مرغوب فيه خصوصًا في الوجه أو الرقبة أو الجفون.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "الأشخاص الذين لا يشعرون بالراحة بسببها",
                    "desc": "يمكن للزوائد الجلدية الموجودة في المناطق الحساسة مثل تحت الإبط أو الفخذ أن تحتك بالجلد أو الملابس، مما يؤدي إلى تهيج الجلد أو النزيف.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "الأشخاص المعرضون للعدوى",
                    "desc": "قد تُصبح الزائدة الجلدية المُلتهبة أو المُتهيجة عرضة للعدوى.",
                    "icon": "fa-solid fa-bacteria"
                },
                {
                    "title": "الأشخاص الذين يبحثون عن حل دائم",
                    "desc": "رغم أن الزوائد الجلدية حميدة، إلا أن إزالتها تضمن عدم عودتها في نفس المكان.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "كيف تستعد لإجراء إزالة الزوائد الجلدية؟",
            "para": "يجب اتباع بعض الخطوات التحضيرية قبل الخضوع لإجراء إزالة الزوائد الجلدية، لضمان علاج سلس وفعّال.",
            "items": [
                {
                    "title": "الاستشارة",
                    "desc": "احجز موعدًا مع طبيب متخصص لتقييم حالة الزوائد الجلدية وتحديد أفضل طريقة لإزالتها.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "تجنب بعض المنتجات",
                    "desc": "امتنع عن استخدام مضادات الميكروبات القوية، والمقشرات الكيميائية، والريتينويدات على المنطقة التي ستُعالج من الزوائد الجلدية.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يتعافى الجلد المُرطب بشكل أسرع، لذا احرص على شرب كمية كافية من الماء قبل موعد العلاج.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "يُفضل تجنب تعرض الجلد لأشعة الشمس المباشرة قبل الإجراء، لأنه قد يؤدي إلى تفاقم تهيج البشرة أثناء مرحلة التعافي.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يحصل المرضى على بشرة ناعمة وخالية من هذه الزوائد غير المرغوب فيها، مع فترة تعافي قصيرة جدًا بعد الإجراء. قد تُلاحظ بعض الاحمرار أو الحساسية البسيطة في المنطقة المعالجة، لكنها تختفي خلال أيام قليلة.",
            "items": [
                {
                    "title": "تحسن فوري",
                    "desc": "تتم إزالة الزوائد الجلدية فورًا، ما يمنح تحسن جمالي فوري للبشرة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "الحد الأدنى من ظهور الندوب",
                    "desc": "يكون احتمال حدوث ندوب طفيفًا للغاية عند تنفيذ الإجراء من قبل متخصص محترف.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "تعافي سريع",
                    "desc": "يعود معظم المرضى إلى أنشطتهم اليومية في نفس اليوم، دون الحاجة إلى فترة تعافي طويلة.",
                    "icon": "fa-solid fa-house-medical"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل إزالة الزوائد الجلدية مؤلمة؟",
                    "answer": "معظم إجراءات إزالة الزوائد الجلدية تسبب الحد الأدنى من الانزعاج. عادةً ما يتم تطبيق مخدر موضعي أو كريم مخدر على المنطقة، مما يجعل الإجراء غير مؤلم تقريبًا."
                },
                {
                    "question": "هل يمكن أن تعود الزوائد الجلدية بعد إزالتها؟",
                    "answer": "بينما لا تعود الزوائد الجلدية المزالة نفسها، إلا أن زوائد جديدة قد تتكون في مناطق أخرى. يمكن أن تساعد العناية بالبشرة ومراقبتها بانتظام في منع ذلك."
                },
                {
                    "question": "كم تستغرق فترة التعافي؟",
                    "answer": "عادةً ما يكون التعافي سريعًا، حيث يستأنف معظم المرضى أنشطتهم اليومية على الفور. قد يشعرون ببعض الاحمرار أو الألم الطفيف الذي يختفي عادةً في غضون أيام قليلة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
